export default __webpack_public_path__ + "static/media/intro_progress.33743773.svg";